import { useEffect } from 'react';

import { useFetcher } from '@remix-run/react';

import type { LoaderData } from '~/hooks/useRecommendations';

const useRecommendations = () => {
  const fetcher = useFetcher<LoaderData>();

  useEffect(() => {
    fetcher.load('/recommendations?index');
  }, []);

  return {
    recommendations: fetcher?.data,
  };
};

export default useRecommendations;
